import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasValue } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import pipe from 'Lib/Hooks/Selectors/pipe';
import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Field, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../Layout';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const importedReferenceDensityId = useSelector(createWorksheetSelector!('ReferenceDensity.ImportedTest.Id')) as Guid;
  const enterFieldRockCorrection = !!useSelector(createWorksheetSelector!('EnterFieldRockCorrection'));
  const hasCorrectionTest = useSelector(
    pipe(createWorksheetSelector!('OversizeCorrectionTest.MeasuredTest'), hasValue)
  );

  return (
    <PageSection heading="Reference Maximum Density">
      <WorksheetAssociatedTestSection
        label="Reference Density Test:"
        name="ReferenceDensity"
        testType="Maximum Dry Density"
        associatedTestModel={{
          imported: {
            importPropertyName: 'ReferenceDensity',
            importedTestResults: (
              <ListFieldSection>
                <Field input={<TextOutput />} label="Supplier" name="ReferenceDensityResults.Supplier" />
                <Field input={<TextOutput />} label="Source" name="ReferenceDensityResults.Source" />
                <Field input={<TextOutput />} label="Material" name="ReferenceDensityResults.Material" />
                <Field input={<TextOutput />} label="Sample Location" name="ReferenceDensityResults.SampleLocation" />
                <Field input={<TextOutput />} label="Method Name" name="ReferenceDensityResults.MaximumDensityMethod" />
                <Field
                  input={<TextOutput />}
                  label="Maximum Dry Density"
                  name="ReferenceDensityResults.MaximumDryDensity"
                />
                <Field
                  input={<TextOutput />}
                  label="Optimum Moisture Content (%)"
                  name="ReferenceDensityResults.OptimumMoistureContent"
                />
              </ListFieldSection>
            ),
            importModel: { Id: importedReferenceDensityId },
            queryParams: {
              limit: 50,
            },
          },
        }}
      />
      <ListFieldSection>
        <Field
          input={<Checkbox />}
          name="EnterFieldRockCorrection"
          label="Enter Field Rock Correction"
          confirm={enterFieldRockCorrection}
          confirmText="This will permanently remove all data for the Field Rock Correction Test. Continue?"
        />
      </ListFieldSection>
      {enterFieldRockCorrection && hasCorrectionTest && (
        <WorksheetAssociatedTestSection
          name="OversizeCorrectionTest"
          testType="Field Rock Correction"
          associatedTestModel={{
            measured: true,
          }}
        />
      )}
    </PageSection>
  );
};

const ArizReferenceDensitySection = withInjectedProps(Section);

export { ArizReferenceDensitySection };
export default ArizReferenceDensitySection;
